import { CustomFormatConstants } from './customFormat.constants';

export const customFormat = (state = {}, action) => {
    switch (action.type) {
        case CustomFormatConstants.GET_ALL_SHOWCASE_CUSTOM_FORMAT:
            return {
                ...state,
                ...action.payload
            };

        case CustomFormatConstants.ALL_SHOWCASE_CUSTOM_FORMAT_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case CustomFormatConstants.GET_ALL_SHOWCASE_CUSTOM_FORMAT_ERROR:
            return {
                ...state,
                error: true
            };
        case CustomFormatConstants.ALL_SHOWCASE_CUSTOM_FORMAT_CURRENT_PAGE:
            return {
                ...state,
                page: action.payload
            };
        case CustomFormatConstants.ALL_SHOWCASE_CUSTOM_FORMAT_LIMIT_PER_PAGE:
            return {
                ...state,
                limit: action.payload
            };
        case CustomFormatConstants.ALL_SHOWCASE_CUSTOM_FORMAT_SEARCH_VALUE:
            return {
                ...state,
                name: action.payload
            };
        case CustomFormatConstants.ALL_SHOWCASE_CUSTOM_FORMAT_STATUS_VALUE:
            return {
                ...state,
                status: action.payload
            };
        case CustomFormatConstants.ALL_SHOWCASE_CUSTOM_FORMAT_LIMIT:
            return {
                ...state,
                total_rows: action.payload
            };
        case CustomFormatConstants.DELETE_SHOWCASE_CUSTOM_FORMAT_SUCCESS:
            return {
                ...state,
                customFormatDelete: action.payload
            };
        case CustomFormatConstants.DELETE_SHOWCASE_CUSTOM_FORMAT_ERROR:
            return {
                ...state,
                customFormatDelete: action.payload
            };
        case CustomFormatConstants.ACTIVATE_SHOWCASE_CUSTOM_FORMAT_SUCCESS:
            return {
                ...state,
                customFormatActivate: action.payload
            };
        case CustomFormatConstants.ACTIVATE_SHOWCASE_CUSTOM_FORMAT_ERROR:
            return {
                ...state,
                customFormatActivate: action.payload
            };
        case CustomFormatConstants.BB_ADD_SHOWCASE_CUSTOM_FORMAT_SUCCESS:
            return {
                ...state,
                addCustomFormatSuccess: true,
                addResp: action.payload
            };
        case CustomFormatConstants.BB_ADD_SHOWCASE_CUSTOM_FORMAT_ERROR:
            return {
                ...state,
                addCustomFormatSuccess: false,
                ...action.payload
            };
        case CustomFormatConstants.BB_ADD_SHOWCASE_CUSTOM_FORMAT_LOADING:
            return {
                ...state,
                addCustomFormatLoading: action.payload
            };
        case CustomFormatConstants.BB_EDIT_SHOWCASE_CUSTOM_FORMAT_SUCCESS:
            return {
                ...state,
                editCustomFormatSuccess: true,
                editResp: action.payload
            };
        case CustomFormatConstants.BB_EDIT_SHOWCASE_CUSTOM_FORMAT_ERROR:
            return {
                ...state,
                editCustomFormatSuccess: false,
                ...action.payload
            };
        case CustomFormatConstants.BB_GET_ALL_CUSTOM_FORMAT_INIT:
            return { ...state, dropDown: { loading: action.payload } };
        case CustomFormatConstants.EMPTY_GET_ALL_CUSTOM_FORMAT:
            return { ...state, dropDown: ""  };    
        case CustomFormatConstants.BB_GET_ALL_CUSTOM_FORMAT_SUCCESS:
        case CustomFormatConstants.BB_GET_ALL_CUSTOM_FORMAT_ERROR:
            return { ...state, dropDown: { data: [...action.payload], loading: false } };
    
        default:
            return state;
    }
}
